import React from "react";

const Header = ({ logout }) => {
  return (
    <nav
      style={{ background: "#006699", height: "62px", color: "#99ddff" }}
      className="nav-fixed"
    >
      <div className="d-flex d-flex justify-content-between m-3">
        <div className="col-md-6">
          <strong className="h5" style={{ color: "#99ddff" }}>
            Racing Feed Client
          </strong>
        </div>
        <div className="col-md-3 text-end">
          <div className="btn-group ">
            <a
              className=""
              href="/#"
              id="navbarDropdownMenuLink"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                className="fas fa-user-circle"
                style={{ color: "#ffffff", fontSize: "23px" }}
              />
            </a>
            <ul className="dropdown-menu dropdown-menu-end ">
              <li>
                <a
                  href="/#"
                  className="dropdown-item text-center p-2"
                  style={{
                    backgroundColor: "#6699cc",
                    color: "black",
                  }}
                >
                  <strong>{localStorage.getItem("userName")}</strong>
                </a>
              </li>
              <li>
                <a
                  href="/#"
                  className="dropdown-item"
                  data-bs-toggle="modal"
                  data-bs-target="#rmqModal"
                >
                  <i className="fa-solid fa-gear"></i> Settings RMQ
                </a>
              </li>
              <li>
                <a href="/#" className="dropdown-item" onClick={() => logout()}>
                  <i className="fa-solid fa-right-from-bracket"></i> Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
